<template>
  <div class="explore-new-goal">
    <top-img-bar />
    <a
      class="text-gradient try-north-top bold text-medium-1 pointer"
      href="https://thenorth.io/"
      target="_blank"
      v-if="!isLoggedIn"
    >
      Try North for free
    </a>
    <div class="container h-100 d-flex flex-column" :class="{ default: !isPrompted }">
      <div class="flex-grow-1">
        <div class="text-center">
          <i
            class="north-logo-icon pointer"
            @click="refresh"
            :class="{ 'top-left': isPrompted }"
          ></i>
        </div>
        <north-a-i-templates-header class="header" />
        <div class="goal-container d-flex justify-content-center px-sm-3 px-0 flex-grow-1">
          <goal-a-i-templates
            :key="componentId"
            class="w-100"
            @select="onGoalSelect"
            @prompt="setPrompted"
          />
        </div>
      </div>
      <div
        class="flex-center py-4 text-secondary flex-column flex-md-row text-center text-md-left"
        v-if="!isLoggedIn"
      >
        North is a simple platform to manage your Strategy, OKRs and Initiatives.
        <a class="ml-2 text-secondary text-underline" href="https://thenorth.io/" target="_blank">
          Try North for free
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import GoalAITemplates from '@/components/templates/GoalAITemplates.vue'
import NorthAITemplatesHeader from '@/components/templates/NorthAITemplatesHeader.vue'
import { ROUTE_NAMES } from '@/constants/routes'
import getURLFromRouteLocation from '@/utils/getURLFromRouteLocation'
import startViewTransition from '@/utils/startViewTransition'
import storeGoalTemplate from '@/utils/templates/storeGoalTemplate'
import TopImgBar from '@/views/TopImgBar.vue'

export default {
  name: 'ExploreNewGoal',
  props: [],
  components: { TopImgBar, GoalAITemplates, NorthAITemplatesHeader },
  data() {
    return {
      isPrompted: false,
      componentId: 1,
      ROUTE_NAMES
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.getters.user
    }
  },
  methods: {
    refresh() {
      this.isPrompted = false
      this.componentId++
    },
    setPrompted() {
      startViewTransition(() => {
        this.isPrompted = true
      })
    },
    onGoalSelect(goal) {
      storeGoalTemplate(goal)
      const doorwayLocation = {
        name: ROUTE_NAMES.DOORWAY,
        query: {
          from: this.$route.name,
          goalTemplate: encodeURIComponent(JSON.stringify(goal))
        }
      }
      const url = getURLFromRouteLocation(doorwayLocation)
      window.top.location.href = url
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.explore-new-goal {
  height: 100vh;
}
.header {
  view-transition-name: header;
}
/deep/ textarea {
  view-transition-name: search-input;
}
.container {
  max-width: 950px;
}
.container {
  padding-top: 24px;
}
.container.default {
  padding-top: 125px;
}
.try-north-top {
  position: absolute;
  top: 16px;
  right: 16px;
}
.text-underline {
  text-decoration: underline;
}
@include media-breakpoint-up(sm) {
  .top-left {
    position: absolute;
    top: 16px;
    left: 16px;
  }
}
</style>
